export default __webpack_public_path__ + "media/images/icons/app-2-9de01598d81be993b4a0eea35fee4622.png";